import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonConstants } from '../common/utilities/commonConstants';
import { PopupComponent } from '../common/utilities/popup/popup.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataLayerService } from './../common/services/dataLayer.service';
import { CookieHandlerService } from './../common/services/cookieHandler.service';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.template.html',
    styleUrls: ['./footer.style.css']
})
export class FooterComponent {
    public footerText = CommonConstants.footerText;
    public Config = { show: false, backdrop: 'static' };
    public prodCode: string;
    public securedProductFlag: boolean;
    public CompanyName: string;
    public consentTokenAvailable = false;
    private consentToken: string;
    public bajajMarketsLogo = environment.serviceBaseUrls.AEMURL + CommonConstants.AEMURLs.CompanyLogoImageUrl;
    /* popup */
    @ViewChild(PopupComponent, { static: false }) public PopupComponent;
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _cookieHandler: CookieHandlerService,
        private _dataLayerService: DataLayerService
    ) {
        this._activatedRoute.queryParams.forEach((params) => {
            this.prodCode = params['prodCode'] || CommonConstants.DEFAULT_EMPTY_STRING;
            this.consentToken = params['consentToken'];
            let pdCode;
            if (window.name.length != 0) {
                pdCode = window.name;
            } else {
                pdCode = this.prodCode;
            }
            this.checkProductCode(pdCode);
            if (this.securedProductFlag) {
                this.CompanyName = 'Bajaj Housing Finance'
            } else {
                this.CompanyName = 'Bajaj Finance'
            }
        });
    }
    public ngOnInit() {
        console.log('footer');
        if (this.consentToken) {
            this.consentTokenAvailable = true;
        }
    }
    public PushDataLayerValues(thisButtonid: string) {
        let thisRoute: string = location.hash;
        const dataLayerEvent: string = CommonConstants.DataLayerEvent;
        const dataLayerPageType: string = (thisRoute.indexOf('#/') > -1) ? thisRoute.substring(2, thisRoute.length) : "";
        const dataLayerPageTitle: string = CommonConstants.DataLayerPageTitleList.FooterPopUp;
        const dataLayerCTAElementId: string = thisButtonid;
        const dataLayerProductCode: string = this._cookieHandler.GetCookie(CommonConstants.QueryParamsKeys.Productcode);
        console.log(location.hash, 'dataLayer init - ', window['dataLayer']);
        this._dataLayerService.setWindiowDataLayer(dataLayerEvent, dataLayerPageType, dataLayerPageTitle,
            dataLayerCTAElementId, dataLayerProductCode);
    }
    public OpenPopup(event) {
        this.Config.show = true;
        this.PopupComponent.ShowModalDialog(event);
    }
    public ClosePopup(event) {
        this.PopupComponent.HideModalDialog(event);
    }
    private checkProductCode(prdCode) {
        if (prdCode === 'DHL' || prdCode === 'DHB' ||
            prdCode === 'DLAP' || prdCode === 'DLAPB') {
            this.securedProductFlag = true;
        } if (prdCode === 'SOL') {
            this.securedProductFlag = false;
        }
    }
}